'use client'

import Navbar from '@/components/landing/Navbar'
import Hero from '@/components/landing/Hero'
import TrustedSection from '@/components/landing/TrustedSection'
import FeaturesGrid from '@/components/landing/FeaturesGrid'
import PlatformOverview from '@/components/landing/PlatformOverview'
import PricingSection from '@/components/landing/PricingSection'
import ComparisonTable from '@/components/landing/ComparisonTable'
import Testimonials from '@/components/landing/Testimonials'
import FAQ from '@/components/landing/FAQ'
import SignupSection from '@/components/landing/SignupSection'
import Footer from '@/components/landing/Footer'
import SectionReveal from '@/components/landing/SectionReveal'

export default function LandingPage() {
  return (
    <main>
      <Navbar />
      <Hero />
      <SectionReveal><TrustedSection /></SectionReveal>
      <SectionReveal><FeaturesGrid /></SectionReveal>
      <SectionReveal><PlatformOverview /></SectionReveal>
      <SectionReveal><PricingSection /></SectionReveal>
      <SectionReveal><ComparisonTable /></SectionReveal>
      <SectionReveal><Testimonials /></SectionReveal>
      <SectionReveal><FAQ /></SectionReveal>
      <SectionReveal><SignupSection /></SectionReveal>
      <Footer />
    </main>
  )
}
